import React from 'react';
import { translations } from '../data/translations';

const AboutSection = ({ lang }) => {
  const t = translations[lang].about;
  
  return (
    <section id="about" className="bg-black py-24 md:py-32">
      <div className="max-w-5xl mx-auto px-6 lg:px-16">
        {/* Section Label */}
        <div className="mb-6">
          <span className="text-[#00FFD1] text-sm font-medium tracking-wider uppercase">
            {t.label}
          </span>
        </div>
        
        {/* Title */}
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white leading-[1.1] tracking-[-0.02em] mb-8">
          {t.title}
        </h2>
        
        {/* Description */}
        <p className="text-lg md:text-xl text-white/85 font-normal leading-relaxed max-w-3xl">
          {t.description}
        </p>
        
        {/* Decorative line */}
        <div className="mt-16 w-24 h-[2px] bg-[#00FFD1]/40" />
      </div>
    </section>
  );
};

export default AboutSection;
